import React, { useContext, useState, useMemo } from "react";

//Styles
import Styles from "./leads-management.module.scss";

//Assets
import IconAllAgentSrc from "assets/all-agent.svg";
import IconAllAgentActiveSrc from "assets/all-agent-active.svg";
import IconResetSrc from "assets/icon-reset.svg";

// Context
import { GlobalContext } from "contexts";
import {
  LeadsManagementProvider,
  useLeadsManagementState,
  useLeadsManagementMethod,
} from "./useLeadsManagementContext";

// Components
import Button from "components/v1/Button";
import ModalPilihAgent from "./modal-pilih-agent";
import TablePrimary from "./table/table-primary";
import TablePrimaryResponded from "./table/table-primary-responded";
import TableSecondary from "./table/table-secondary";
import ModalDownload from "components/molecules/leads-management/modal-download";

const LeadsManagement = () => {
  const { profile, isRoleProjectAdmin } = useContext(GlobalContext);
  const [showStatusDropdown, setShowStatusDropdown] = useState(false);
  const {
    LEADS_STATUS,
    listLeads,
    agents,
    params,
    listLeadPrimaries,
    SUB_LEADS_STATUS,
    STATUS,
  } = useLeadsManagementState();

  const {
    handleChangeLeadStatus,
    handleGetLeads,
    handleChangeAgen,
    setParams,
    handleChangeSubLeadStatus,
    handleReset,
  } = useLeadsManagementMethod();

  const [isOpenModalAgent, setIsOpenModalAgent] = useState(false);
  const [selectedAgen, setSelectedAgen] = useState(null);
  const [isOpenModalDownload, setIsOpenModalDownload] = useState(false);

  return (
    <>
      <div className={Styles["wrapper"]}>
        <div className={Styles["header"]}>
          <h1 className={Styles["title"]}>Leads Management</h1>
          <h1 className={Styles["welcome"]}>
            Selamat datang kembali, {profile?.full_name}!
          </h1>
        </div>

        <div className={`${Styles["content"]}`}>
          <div className="px-4 py-2 flex items-center justify-between">
            <div className="flex border-b border-[#E6E7E8]">
              <button
                onClick={() => handleChangeLeadStatus(LEADS_STATUS.primary)}
                className={`px-4 py-2 text-sm font-medium ${
                  params.lead_status === LEADS_STATUS.primary
                    ? "border-0 border-b-2 border-solid border-[#252526]"
                    : ""
                }`}
              >
                <span>Primary</span>
              </button>
              {!isRoleProjectAdmin && (
                <button
                  onClick={() => handleChangeLeadStatus(LEADS_STATUS.secondary)}
                  className={`px-4 py-2 text-sm font-medium ${
                    params.lead_status === LEADS_STATUS.secondary
                      ? "border-0 border-b-2 border-solid border-[#252526]"
                      : ""
                  }`}
                >
                  <span>Secondary</span>
                </button>
              )}
              <button
                onClick={() => handleChangeLeadStatus(LEADS_STATUS.ditanggapi)}
                className={`px-4 py-2 text-sm font-medium ${
                  params.lead_status === LEADS_STATUS.ditanggapi
                    ? "border-0 border-b-2 border-solid border-[#252526]"
                    : ""
                }`}
              >
                <span>Ditanggapi</span>
              </button>
            </div>

            <Button
              onClick={() => setIsOpenModalDownload(true)}
              text="Download"
              type="secondary"
            />
          </div>

          {params.lead_status === LEADS_STATUS.ditanggapi && (
            <div className={Styles["actions-wrapper"]}>
              <div className={Styles["btns-wrapper"]}>
                <button
                  onClick={() =>
                    handleChangeSubLeadStatus(SUB_LEADS_STATUS.primary)
                  }
                  className={`${Styles["btn"]} ${
                    Styles[
                      params.sub_lead_status === SUB_LEADS_STATUS.primary
                        ? "active"
                        : ""
                    ]
                  }`}
                >
                  <span>Primary</span>
                </button>
                {!isRoleProjectAdmin && (
                  <button
                    onClick={() =>
                      handleChangeSubLeadStatus(SUB_LEADS_STATUS.secondary)
                    }
                    className={`${Styles["btn"]} ${
                      Styles[
                        params.sub_lead_status === SUB_LEADS_STATUS.secondary
                          ? "active"
                          : ""
                      ]
                    }`}
                  >
                    <span>Secondary</span>
                  </button>
                )}
              </div>

              <div className="flex items-center">
                {params.sub_lead_status === SUB_LEADS_STATUS.primary && (
                  <div className="relative mr-2">
                    <div className="relative w-[140px]">
                      <button
                        type="button"
                        onClick={() =>
                          setShowStatusDropdown(!showStatusDropdown)
                        }
                        className="w-full px-3 py-1.5 text-sm border-[5px] border-solid border-[#E6E7E8] rounded bg-white cursor-pointer gap-2 flex items-center justify-between"
                      >
                        <span className="text-[13px]">
                          {params?.status?.label || "Semua Status"}
                        </span>
                        <div
                          className={`${!showStatusDropdown ? "rotate-180" : ""}`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <path
                              d="M1.98448 7.23448L5.73448 3.48448C5.76931 3.44961 5.81066 3.42195 5.85619 3.40308C5.90171 3.38421 5.95051 3.3745 5.99979 3.3745C6.04907 3.3745 6.09787 3.38421 6.14339 3.40308C6.18892 3.42195 6.23028 3.44961 6.2651 3.48448L10.0151 7.23448C10.0855 7.30484 10.125 7.40028 10.125 7.49979C10.125 7.5993 10.0855 7.69474 10.0151 7.7651C9.94474 7.83547 9.8493 7.875 9.74979 7.875C9.65028 7.875 9.55484 7.83547 9.48448 7.7651L5.99979 4.27995L2.5151 7.7651C2.48026 7.79995 2.4389 7.82758 2.39338 7.84644C2.34786 7.8653 2.29906 7.875 2.24979 7.875C2.20052 7.875 2.15173 7.8653 2.1062 7.84644C2.06068 7.82758 2.01932 7.79995 1.98448 7.7651C1.94964 7.73026 1.922 7.6889 1.90314 7.64338C1.88429 7.59786 1.87458 7.54906 1.87458 7.49979C1.87458 7.45052 1.88429 7.40173 1.90314 7.35621C1.922 7.31068 1.94964 7.26932 1.98448 7.23448Z"
                              fill="#252526"
                            />
                          </svg>
                        </div>
                      </button>

                      {showStatusDropdown && (
                        <div className="absolute z-10 mt-1 w-full bg-white border-[0.5px] border-solid border-[#D8D8D9] rounded-md shadow-[0_2px_8px_0_rgba(37,37,38,0.25)]">
                          {STATUS?.map((status, idx) => (
                            <div
                              key={idx}
                              onClick={() => {
                                setParams({ ...params, status: status });
                                setShowStatusDropdown(false);
                              }}
                              className={`px-2 h-[30px] text-[13px] cursor-pointer flex items-center gap-2 border-b-[0.5px] border-solid border-[#D8D8D9] first:rounded-t-md last:rounded-b-md ${
                                status.value === params.status.value
                                  ? "bg-[#252526] text-white"
                                  : ""
                              }`}
                            >
                              {status.label}

                              {status.value === params.status.value && (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                >
                                  <path
                                    d="M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM10.8538 6.85375L7.35375 10.3538C7.30732 10.4002 7.25217 10.4371 7.19147 10.4623C7.13077 10.4874 7.06571 10.5004 7 10.5004C6.9343 10.5004 6.86923 10.4874 6.80853 10.4623C6.74783 10.4371 6.69269 10.4002 6.64625 10.3538L5.14625 8.85375C5.05243 8.75993 4.99972 8.63268 4.99972 8.5C4.99972 8.36732 5.05243 8.24007 5.14625 8.14625C5.24007 8.05243 5.36732 7.99972 5.5 7.99972C5.63268 7.99972 5.75993 8.05243 5.85375 8.14625L7 9.29313L10.1463 6.14625C10.1927 6.09979 10.2479 6.06294 10.3086 6.0378C10.3693 6.01266 10.4343 5.99972 10.5 5.99972C10.5657 5.99972 10.6308 6.01266 10.6915 6.0378C10.7521 6.06294 10.8073 6.09979 10.8538 6.14625C10.9002 6.1927 10.9371 6.24786 10.9622 6.30855C10.9873 6.36925 11.0003 6.4343 11.0003 6.5C11.0003 6.5657 10.9873 6.63075 10.9622 6.69145C10.9371 6.75214 10.9002 6.8073 10.8538 6.85375Z"
                                    fill="#02AC5B"
                                  />
                                </svg>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                <Button
                  text={
                    !!params?.full_name ? params.full_name : "Semua Marketing"
                  }
                  icon={
                    !!params?.full_name
                      ? IconAllAgentActiveSrc
                      : IconAllAgentSrc
                  }
                  type={!!params?.full_name ? "primary" : "secondary"}
                  size="xl"
                  className="mr-2"
                  onClick={() => setIsOpenModalAgent(true)}
                />
                <Button
                  icon={IconResetSrc}
                  type="negative"
                  size="xl"
                  iconClassName="!m-0"
                  disabled={!params?.full_name}
                  onClick={handleReset}
                />
              </div>
            </div>
          )}

          <div className="p-4 overflow-y-auto w-full">
            {params.lead_status === LEADS_STATUS.primary && (
              <TablePrimary data={listLeadPrimaries} />
            )}
            {params.lead_status === LEADS_STATUS.ditanggapi &&
              params.sub_lead_status === SUB_LEADS_STATUS.primary && (
                <TablePrimaryResponded data={listLeadPrimaries} />
              )}

            {(params.lead_status === LEADS_STATUS.secondary ||
              (params.lead_status === LEADS_STATUS.ditanggapi &&
                params.sub_lead_status === SUB_LEADS_STATUS.secondary)) && (
              <TableSecondary
                data={listLeads}
                LEADS_STATUS={LEADS_STATUS}
                leadStatus={params.lead_status}
                handleGetLeads={handleGetLeads}
                subLeadStatus={params.sub_lead_status}
                SUB_LEADS_STATUS={SUB_LEADS_STATUS}
              />
            )}
          </div>
        </div>
      </div>

      <ModalPilihAgent
        onClose={() => {
          setIsOpenModalAgent(false);
        }}
        agents={agents}
        onSelect={(agent) => {
          handleChangeAgen(agent);
          setIsOpenModalAgent(false);
        }}
        isOpen={isOpenModalAgent}
        selectedAgen={selectedAgen}
        setSelectedAgen={setSelectedAgen}
      />

      <ModalDownload
        isOpen={isOpenModalDownload}
        onClose={() => setIsOpenModalDownload(false)}
      />
    </>
  );
};

const LeadsManagementWrapper = ({ ...props }) => (
  <LeadsManagementProvider>
    <LeadsManagement {...props} />
  </LeadsManagementProvider>
);

export default LeadsManagementWrapper;
